import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CustomRadio extends Component {
  static propTypes = {
    number: PropTypes.number,
    label: PropTypes.string,
    option: PropTypes.any,
    name: PropTypes.string
  }
  render() {
    const { number, label, option, name, ...rest } = this.props;

    return (
      <div className='radio'>
        <input id={number} name={name} type='radio' value={option} {...rest} />
        <label htmlFor={number}>{label}</label>
      </div>
    );
  }
}

export default CustomRadio;



// WEBPACK FOOTER //
// ./src/components/CustomRadio/CustomRadio.js